var _QueryStringCollection_items;
import { __classPrivateFieldGet, __classPrivateFieldSet } from "tslib";
import convertQueryStringItemToObject from './utils/convertQueryStringItemToObject';
import deserializeQS from './utils/deserializeQS';
import serializeQueryStringItems from './utils/serializeQueryStringItems';
import { convertObjectToQueryStringItem } from './utils/convert';
export default class QueryStringCollection {
    constructor(items = []) {
        _QueryStringCollection_items.set(this, void 0);
        __classPrivateFieldSet(this, _QueryStringCollection_items, items, "f");
    }
    get items() {
        return __classPrivateFieldGet(this, _QueryStringCollection_items, "f");
    }
    item(name) {
        const items = this.items.filter(i => i.name === name);
        if (items.length > 1) {
            return items.map(i => i.value);
        }
        else if (items.length > 0) {
            return items[0].value;
        }
    }
    toObject() {
        return convertQueryStringItemToObject(__classPrivateFieldGet(this, _QueryStringCollection_items, "f"));
    }
    toString() {
        return serializeQueryStringItems(__classPrivateFieldGet(this, _QueryStringCollection_items, "f"), true);
    }
    static merge(...queryStringCollections) {
        return QueryStringCollection.createFromObject(Object.assign({}, ...queryStringCollections.map(qsc => qsc.toObject())));
    }
    static createFromQueryString(queryString) {
        return new QueryStringCollection(deserializeQS(queryString));
    }
    static createFromObject(queryStringObject) {
        return new QueryStringCollection(convertObjectToQueryStringItem(queryStringObject));
    }
}
_QueryStringCollection_items = new WeakMap();
